import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, setToken, getToken, clearToken } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = checking, false = logged out, object = logged in
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      if (!getToken()) { setUser(false); return; }
      try {
        const me = await api.me();
        setUser(me);
      } catch (e) {
        clearToken();
        setUser(false);
      }
    })();
  }, []);

  const login = useCallback(async (username, password) => {
    setError("");
    const res = await api.login(username, password);
    setToken(res.token);
    setUser(res.user);
    return true;
  }, []);

  const register = useCallback(async (username, password) => {
    setError("");
    const res = await api.register(username, password);
    setToken(res.token);
    setUser(res.user);
    return true;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, error, setError, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
